import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import Div100vh from 'react-div-100vh';
export default function FullHeight(_a) {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return _jsx(Div100vh, Object.assign({}, rest, { children: children }));
}
